import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CustomFieldControl, DataService, SharedModule } from '@vendure/admin-ui/core';
import { Observable } from 'rxjs';
import { Page } from '../generated';
import { GET_PAGE } from '../graphql';

@Component({
    selector: 'relation-page-display',
    template: `
        <div class="flex items-center">
            <div *ngIf="formControl.value as page; else emptyPage" class="mr-2">
                <a class="button-ghost" [routerLink]="['/extensions', 'site-pages', page.id]">
                    <span>{{ page.name }}</span>
                    <clr-icon shape="arrow right"></clr-icon>
                </a>
            </div>
            <ng-template #emptyPage>
                <input
                    type="text" [formControl]="formControl"
                    placeholder="Create a Page for this Product first."
                    readonly
                />
            </ng-template>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [SharedModule],
})
export class RelationPageDisplayComponent implements OnInit, CustomFieldControl {
    @Input() readonly: boolean;
    @Input() formControl: FormControl;
    @Input() config: any;

    page$: Observable<Page>;

    constructor(private dataService: DataService) {}

    ngOnInit() {
        this.page$ = this.dataService.query(GET_PAGE, {
            id: this.formControl.value?.id,
        }).mapSingle((data:any) => data.page);
    }
}
